import { Skull } from "lucide-react";
import { useSettings, resolveImageUrl } from "@/context/SettingsContext";

export function LogoMark({ size = 32, className = "" }) {
  const { settings } = useSettings();
  const src = resolveImageUrl(settings?.logo_url);

  if (src) {
    return (
      <div
        className={`relative inline-flex items-center justify-center rounded-full overflow-hidden ${className}`}
        style={{
          width: size,
          height: size,
          background: "radial-gradient(circle at 30% 30%, #27272a, #09090b)",
          border: "1px solid rgba(192,192,192,0.35)",
          boxShadow: "0 0 10px rgba(136,8,8,0.25)",
        }}
        aria-hidden
      >
        <img src={src} alt="" className="w-full h-full object-cover" draggable={false} />
      </div>
    );
  }

  return (
    <div
      className={`relative inline-flex items-center justify-center rounded-full ${className}`}
      style={{
        width: size,
        height: size,
        background: "radial-gradient(circle at 30% 30%, #27272a, #09090b)",
        border: "1px solid rgba(192,192,192,0.35)",
        boxShadow: "inset 0 0 12px rgba(136,8,8,0.35), 0 0 10px rgba(136,8,8,0.25)",
      }}
      aria-hidden
    >
      <Skull size={size * 0.55} className="text-silver" style={{ filter: "drop-shadow(0 0 4px rgba(136,8,8,0.9))" }} />
    </div>
  );
}

export function LogoLockup({ compact = false }) {
  return (
    <div className="flex items-center gap-3" data-testid="logo-lockup">
      <LogoMark size={compact ? 32 : 40} />
      <div className="leading-tight">
        <div className="font-display text-base sm:text-lg font-bold tracking-[0.25em] text-silver uppercase">
          Ballhoot<span className="text-crimson">’</span>s
        </div>
        {!compact && (
          <div className="font-display text-[10px] sm:text-xs tracking-[0.5em] text-zinc-500 uppercase">Tavern</div>
        )}
      </div>
    </div>
  );
}
